import Slider from '../../common/_slider';
import { Drawer } from '../../common/_drawer';

export default class Main {
    constructor() {
        this.setSlider();
        this.setDrawer();
    }

    setSlider() {
        const opt = {
            spaceBetween: 20,
            loop: true,
            pagination: { el: '.js-disco-pagenation', clickable: true },
            breakpoints: {
                768: {
                    allowTouchMove: false,
                },
            },
        };

        const slider = new Slider('.js-disco-slider', opt);
        const headerSlider = new Slider('.js-disco-header-slider', opt);
    }

    setDrawer() {
        const status = {};
        const targets = document.querySelectorAll('[data-drawer]');
        targets.forEach((el) => {
            const drawer = new Drawer(el, status);
        });
    }
}
